export default function Reviews() {
  const reviews = [
    {
      rating: 5,
      title: '還元率が本当に高い',
      comment: 'どこで使っても1.2%還元なので、メインカードとして使っています。年会費無料でこの還元率は他にないと思います。ポイント交換も簡単で、Pontaポイントに交換してローソンで使っています。',
      author: '30代男性 / 会社員',
      date: '2024年1月'
    },
    {
      rating: 5,
      title: '提携サービスでさらにお得',
      comment: '飲食店予約サービスや宿泊予約サービスを使うと、通常の1.2%に加えて最大3%のポイントが貯まるので、旅行や外食が多い私にはぴったりです。年間で数万円分のポイントが貯まりました。',
      author: '40代女性 / 自営業',
      date: '2023年12月'
    },
    {
      rating: 4,
      title: '電子マネーチャージでもポイント',
      comment: 'モバイルSuicaへのチャージでも1.2%還元されるのが嬉しいです。通勤でSuicaを使うので、チャージ分と利用分で二重にポイントが貯まります。ただ、ポイント交換が必要なのが少し手間です。',
      author: '20代男性 / 会社員',
      date: '2024年2月'
    },
    {
      rating: 5,
      title: '年会費無料で高還元',
      comment: '年会費無料のカードでは最高クラスの還元率だと思います。家族カードも無料なので、家族全員で使っています。貯まったポイントはdポイントに交換して、コンビニやドラッグストアで使っています。',
      author: '50代女性 / 主婦',
      date: '2023年11月'
    },
    {
      rating: 4,
      title: '旅行保険も充実',
      comment: '還元率の高さだけでなく、旅行保険も充実しているのが良いです。海外旅行保険が最高2,000万円、国内旅行保険も最高1,000万円付帯しているので、旅行の際も安心です。',
      author: '30代女性 / 会社員',
      date: '2024年1月'
    },
    {
      rating: 5,
      title: 'コスパ最強のカード',
      comment: '年会費無料で1.2%還元、さらに旅行保険やショッピング保険も付帯。コスパで選ぶなら間違いなくこのカードです。入会キャンペーンで6,000円分のポイントももらえて、すぐに元が取れました。',
      author: '40代男性 / 会社員',
      date: '2023年12月'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-4">
          利用者の口コミ
        </h2>
        <p className="text-center text-gray-600 mb-12 max-w-2xl mx-auto">
          実際に利用している方々の生の声をご紹介します
        </p>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.map((review, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white rounded-xl p-6 shadow-lg border border-gray-200 hover:border-orange-300 hover:shadow-xl transition-all duration-300"
            >
              <div className="flex items-center gap-1 mb-3">
                {[...Array(5)].map((_, i) => (
                  <i
                    key={i}
                    className={`ri-star-${i < review.rating ? 'fill' : 'line'} ${
                      i < review.rating ? 'text-orange-500' : 'text-gray-300'
                    } text-lg w-5 h-5 flex items-center justify-center`}
                  ></i>
                ))}
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">
                {review.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-4">
                {review.comment}
              </p>
              <div className="flex items-center justify-between text-xs text-gray-500 pt-4 border-t border-gray-200">
                <span>{review.author}</span>
                <span>{review.date}</span>
              </div>
            </div>
          ))}
        </div>
        <div className="mt-12 bg-gradient-to-r from-orange-50 to-red-50 rounded-xl p-8 border border-orange-200 text-center">
          <div className="flex items-center justify-center gap-2 mb-4">
            <div className="flex items-center gap-1">
              {[...Array(5)].map((_, i) => (
                <i
                  key={i}
                  className="ri-star-fill text-orange-500 text-2xl w-6 h-6 flex items-center justify-center"
                ></i>
              ))}
            </div>
            <span className="text-3xl font-bold text-gray-900">4.7</span>
            <span className="text-gray-600">/ 5.0</span>
          </div>
          <p className="text-gray-700 font-semibold">
            利用者満足度が非常に高いクレジットカードです
          </p>
        </div>
      </div>
    </section>
  );
}
